import { apiGet, apiPatch } from './client';
import type { AccountPurpose, AccountPurposeBatchRequest } from '../types/AccountPurpose';

export function getAccountPurposes(): Promise<AccountPurpose[]> {
  return apiGet<AccountPurpose[]>('/api/account-purposes');
}

export function saveBatchAccountPurposes(added: AccountPurpose[], modified: AccountPurpose[], deletedIds: number[]): Promise<AccountPurpose[]> {
  return apiPatch<AccountPurposeBatchRequest, AccountPurpose[]>('/api/account-purposes/batch', { added, modified, deleted: deletedIds });
}
